/**
 * Extrai a mensagem real do erro vindo do backend (axios).
 *
 * <p>O backend retorna <c>{ message: "..." }</c> em 400/403/404/500. Sem este
 * helper, o front mostra "Erro ao salvar. Tente novamente." mascarando a
 * causa real ("Você só pode conceder permissões que você mesmo possui",
 * "Senha atual incorreta", etc).</p>
 *
 * <p>Ordem de fallback: axios response.data.message → Error.message → fallback.</p>
 */
export function extrairMensagemErro(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const resp = (err as { response?: { data?: { message?: string } } }).response;
    if (resp?.data?.message) return resp.data.message;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
